<template>
  <div>
    <Header/>
    <div class="container flex flex_between tijian_body">
      <div style="width:calc(100% - 420px);box-shadow: 0 0 5px 5px rgba(0,0,0,0.05);">
        <Tijian :searchKey="searchKey"/>
      </div>
      <div class="right_body">
        <div class="right_nav">
          <div class="right_nav_title">
            <p>热门产品与服务</p>
            <b>HOT</b>
          </div>
          <dl class="right_nav_wrap" v-for="item in navList" :key="item.id">
            <dt class="right_nav_subtitle"><span>{{ item.title }}</span></dt>
            <dd class="right_nav_item"
                v-for="child in item.navWrap"
                @click="goPages(child)"
            >
              <p class="qipao" v-if="child.tips==='new'||child.tips==='hot'" :class="{'new':child.tips==='new'}">
                <i class="iconfont">&#xe613;</i>
                <span>{{ child.tips==='new'?'新':'热' }}</span>
              </p>
              <div class="right_nav_icon">
                <span class="iconfont" v-html="child.icon"></span>
              </div>
              {{ child.name }}
            </dd>
          </dl>
        </div>
        <!--
        <div class="download_app flex flex_between">
          <img src="@/assets/xinyong/qrcode.jpg" alt="" title="二维码" class="qrcode">
          <div class="down_info flex flex_column flex_between">
            <div class="down_name">
              <p>三维信用体检报告</p>
              <span>手机端</span>
            </div>
            <div class="down_tips">
              微信扫一扫 <br>
              随时随地查阅与分享报告
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Tijian from "@/views/Tijian";
export default {
  name: "xinyongTest",
  components:{
    Header,Tijian
  },
  data(){
    return{
      navList:[
        {
          id:0,
          title:"模块化产品",
          navWrap:[
            {
              id:0,
              icon:"&#xe604;",
              name:"三维信用体检",
              tips:"hot",
              path:"/module?id=7&text=三维信用诊断系统"
            },
            {
              id:1,
              icon:"&#xe675;",
              name:"企业信管家",
              tips:"new",
              path:"/module?id=8&text=企业信管家"
            },
            {
              id:2,
              icon:"&#xe6aa;",
              name:"信用监管套餐",
              tips:"hot",
              path:"/module?id=9&text=信用监管套餐"
            },
            {
              id:3,
              icon:"&#xe656;",
              name:"信用档案系统",
              path:"/module?id=10&text=信用档案系统"
            },
            {
              id:4,
              icon:"&#xe627;",
              name:"信用预警机",
              path:"/module?id=11&text=信用预警机"
            }
          ]
        },
        {
          id:1,
          title:"撰写与辅导",
          navWrap:[
            {
              id:5,
              icon:"&#xe633;",
              name:"规划编制",
              tips:"hot",
              path:"zhengxinfu/1"
            },
            {
              id:6,
              icon:"&#xe733;",
              name:"制度起草",
              path:"zhengxinfu/2"
            },
            {
              id:7,
              icon:"&#xe602;",
              name:"专家辅导",
              tips:"hot",
              path:"zhengxinfu/3"
            },
            {
              id:8,
              icon:"&#xe695;",
              name:"创新模式打造",
               path:"zhengxinfu/4"
            },
            {
              id:9,
              icon:"&#xe88a;",
              name:"清单式管理",
               path:"zhengxinfu/5"
            },
            {
              id:10,
              icon:"&#xe601;",
              name:"项目路径研究",
               path:"zhengxinfu/6"
            },

          ]
        }
      ],
      searchKey:this.$route.query.searchKey || null
    }
  },
  methods:{
    goPages(item){
      this.$router.push(item.path)
    }
  }
};
</script>

<style scoped lang="less">
  .tijian_body{
    padding: 24px 0;
    align-items: flex-start;
  }
  .download_app{
    margin-top: 24px;
    background: linear-gradient(135deg, #0BB5E2, #19DEC1);
    border-radius: 1px;
    padding: 30px 24px;
    align-items: stretch;
    img{
      flex:0 0 132px;
      box-sizing: border-box;
      width: 132px;
      background: #FFFFFF;
      padding: 7px;
    }
    .down_info{
      color: #fff;
      font-size: 16px;
      flex: 0 0 192px;
      .down_name{
        p{
          font-size: 24px;
          color: #FEF5D6;
          margin-bottom: 2px;
        }
        span{
          display: inline-block;
          border: 1px solid #fff;
          padding: 3px 6px;
          border-radius: 4px;
          line-height: 1;
        }
      }
    }
  }
  .right_nav{
    width: 400px;
    background: #FFFFFF;
    box-shadow: 0 0 5px 5px rgba(0,0,0,0.05);
    .right_nav_title{
      position: relative;
      height: 62px;
      background: #E7E7E7;
      line-height: 62px;
      padding-left: 26px;
      font-size: 20px;
      color: #005293;
      b{
        font-size: 60px;
        color: #D9D9D9;
        position: absolute;
        top: -6px;
        right:7px;
        font-style: italic;
        text-shadow: 2px 3px 1px #D9D9D9;
      }
    }
    .right_nav_wrap{
      padding: 18px 26px 0;
      .right_nav_subtitle{
        position: relative;
        margin-bottom: 3px;
        span{
          font-size: 16px;
          color: #005293;
          background: #fff;
          padding-right: 12px;
          position: relative;
          z-index: 1;
        }
        &::after{
          content: " ";
          display: block;
          width: 100%;
          height: 2px;
          background: #82B7E1;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translate(0,-50%);
        }
      }
      .right_nav_item{
        position: relative;
        display: inline-block;
        width: 33.33%;
        text-align: center;
        font-size: 14px;
        padding: 16px 0;
        cursor: pointer;
        .right_nav_icon{
          position: relative;
          text-align: center;
          .iconfont{
            display: inline-block;
            color: #005293;
            font-size: 34px;
            margin-bottom: 12px;
          }
        }
        .qipao{
          position: absolute;
          top:0;
          right:13px;
          text-align: center;
          width: 32px;
          span{
            color: #fff;
            font-size: 12px;
            position: relative;
            z-index: 1;
            line-height: 28px;
          }
          .iconfont{
            position: absolute;
            top:0;
            right:0;
            font-size: 32px;
            color: #E93A3A;
          }
          &.new{
            .iconfont{
              color: #11DEA2;
            }
          }
        }
      }
    }
  }
</style>
